import React, { memo } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { IconVerfied } from '@prisjakt/ui/icon';
import { Logo, LogoWrapper, AuthorizedDealerBadge } from './styles';
import { BodySmallText } from '@prisjakt/ui/text/variants';

type Props = {
  id: number;
  storeName: string;
  brandName: string;
  logo?: string | null;
  pathName: string;
};

export const RecommendedRetailer = memo((props: Props) => {
  const { storeName, brandName, logo, pathName, id } = props;
  const { linkTo, t } = useAppContext();

  return (
    <>
      {logo && (
        <LogoWrapper to={linkTo('brand', { pathName, id })}>
          <Logo src={logo} alt={brandName} />
        </LogoWrapper>
      )}

      <AuthorizedDealerBadge
        text={
          <BodySmallText weight={600} style={{ fontSize: 12 }}>
            {t('store', 'store.recommended-retailer-brand', {
              brand: brandName,
              store: storeName,
            })}
          </BodySmallText>
        }
        icon={IconVerfied}
        color="BLUE"
      />
    </>
  );
});
